import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  categoryId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type CategoryAggregator = {
  __typename?: 'CategoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CategoryAggregatorSum>;
  avg?: Maybe<CategoryAggregatorAvg>;
  min?: Maybe<CategoryAggregatorMin>;
  max?: Maybe<CategoryAggregatorMax>;
};

export type CategoryAggregatorAvg = {
  __typename?: 'CategoryAggregatorAvg';
  order?: Maybe<Scalars['Float']>;
};

export type CategoryAggregatorMax = {
  __typename?: 'CategoryAggregatorMax';
  order?: Maybe<Scalars['Float']>;
};

export type CategoryAggregatorMin = {
  __typename?: 'CategoryAggregatorMin';
  order?: Maybe<Scalars['Float']>;
};

export type CategoryAggregatorSum = {
  __typename?: 'CategoryAggregatorSum';
  order?: Maybe<Scalars['Float']>;
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  values?: Maybe<Array<Maybe<Category>>>;
  groupBy?: Maybe<CategoryGroupBy>;
  aggregate?: Maybe<CategoryAggregator>;
};

export type CategoryConnectionCategoryId = {
  __typename?: 'CategoryConnectionCategoryId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionCreated_At = {
  __typename?: 'CategoryConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionDescription = {
  __typename?: 'CategoryConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionId = {
  __typename?: 'CategoryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionLabel = {
  __typename?: 'CategoryConnectionLabel';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionName = {
  __typename?: 'CategoryConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionOrder = {
  __typename?: 'CategoryConnectionOrder';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionParent = {
  __typename?: 'CategoryConnectionParent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryConnectionUpdated_At = {
  __typename?: 'CategoryConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CategoryConnection>;
};

export type CategoryGroupBy = {
  __typename?: 'CategoryGroupBy';
  id?: Maybe<Array<Maybe<CategoryConnectionId>>>;
  created_at?: Maybe<Array<Maybe<CategoryConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<CategoryConnectionUpdated_At>>>;
  categoryId?: Maybe<Array<Maybe<CategoryConnectionCategoryId>>>;
  name?: Maybe<Array<Maybe<CategoryConnectionName>>>;
  description?: Maybe<Array<Maybe<CategoryConnectionDescription>>>;
  parent?: Maybe<Array<Maybe<CategoryConnectionParent>>>;
  label?: Maybe<Array<Maybe<CategoryConnectionLabel>>>;
  order?: Maybe<Array<Maybe<CategoryConnectionOrder>>>;
};

export type CategoryInput = {
  categoryId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentFestivalBannerInput = {
  position: FestivalPosition;
  banner?: Maybe<Array<Maybe<ComponentMediaMediaInput>>>;
  label?: Maybe<Scalars['String']>;
};

export type ComponentFestivalBanners = {
  __typename?: 'ComponentFestivalBanners';
  id: Scalars['ID'];
  position: FestivalPosition;
  banner?: Maybe<Array<Maybe<ComponentMediaMedia>>>;
  label?: Maybe<Scalars['String']>;
};

export type ComponentFestivalLineup = {
  __typename?: 'ComponentFestivalLineup';
  id: Scalars['ID'];
  title: Scalars['String'];
  banners?: Maybe<Array<Maybe<ComponentMediaImageBanner>>>;
};

export type ComponentFestivalLineupInput = {
  title: Scalars['String'];
  banners?: Maybe<Array<Maybe<ComponentMediaImageBannerInput>>>;
};

export type ComponentMediaImageBanner = {
  __typename?: 'ComponentMediaImageBanner';
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  image?: Maybe<UploadFile>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type ComponentMediaImageBannerInput = {
  link?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type ComponentMediaMedia = {
  __typename?: 'ComponentMediaMedia';
  id: Scalars['ID'];
  link?: Maybe<Scalars['String']>;
  media?: Maybe<UploadFile>;
  label?: Maybe<Scalars['String']>;
};

export type ComponentMediaMediaInput = {
  link?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type ComponentPageCategories = {
  __typename?: 'ComponentPageCategories';
  id: Scalars['ID'];
  category?: Maybe<Category>;
  label: Scalars['String'];
};

export type ComponentPageCategoryInput = {
  category?: Maybe<Scalars['ID']>;
  label: Scalars['String'];
};

export type ComponentPageDisplayOption = {
  __typename?: 'ComponentPageDisplayOption';
  id: Scalars['ID'];
  pc?: Maybe<Scalars['Int']>;
  mobile?: Maybe<Scalars['Int']>;
  categoryLimit?: Maybe<Scalars['Int']>;
};

export type ComponentPageDisplayOptionInput = {
  pc?: Maybe<Scalars['Int']>;
  mobile?: Maybe<Scalars['Int']>;
  categoryLimit?: Maybe<Scalars['Int']>;
};

export type ComponentPostHashTag = {
  __typename?: 'ComponentPostHashTag';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type ComponentPostHashTagInput = {
  name?: Maybe<Scalars['String']>;
};

export type ComponentPostRelated = {
  __typename?: 'ComponentPostRelated';
  id: Scalars['ID'];
  post?: Maybe<Post>;
  memo?: Maybe<Scalars['String']>;
};

export type ComponentPostRelatedInput = {
  post?: Maybe<Scalars['ID']>;
  memo?: Maybe<Scalars['String']>;
};

export type ComponentProgramPlaylist = {
  __typename?: 'ComponentProgramPlaylist';
  id: Scalars['ID'];
};

export type ComponentProgramPlaylistInput = {
  _?: Maybe<Scalars['String']>;
};



export type Festival = {
  __typename?: 'Festival';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title: Scalars['String'];
  place: Scalars['String'];
  coverImage?: Maybe<UploadFile>;
  info: Scalars['String'];
  banners?: Maybe<Array<Maybe<ComponentFestivalBanners>>>;
  lineup?: Maybe<Array<Maybe<ComponentFestivalLineup>>>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  posts?: Maybe<Array<Maybe<Post>>>;
};


export type FestivalPostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type FestivalAggregator = {
  __typename?: 'FestivalAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<FestivalAggregatorSum>;
  avg?: Maybe<FestivalAggregatorAvg>;
  min?: Maybe<FestivalAggregatorMin>;
  max?: Maybe<FestivalAggregatorMax>;
};

export type FestivalAggregatorAvg = {
  __typename?: 'FestivalAggregatorAvg';
  year?: Maybe<Scalars['Float']>;
};

export type FestivalAggregatorMax = {
  __typename?: 'FestivalAggregatorMax';
  year?: Maybe<Scalars['Float']>;
};

export type FestivalAggregatorMin = {
  __typename?: 'FestivalAggregatorMin';
  year?: Maybe<Scalars['Float']>;
};

export type FestivalAggregatorSum = {
  __typename?: 'FestivalAggregatorSum';
  year?: Maybe<Scalars['Float']>;
};

export type FestivalConnection = {
  __typename?: 'FestivalConnection';
  values?: Maybe<Array<Maybe<Festival>>>;
  groupBy?: Maybe<FestivalGroupBy>;
  aggregate?: Maybe<FestivalAggregator>;
};

export type FestivalConnectionCoverImage = {
  __typename?: 'FestivalConnectionCoverImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionCreated_At = {
  __typename?: 'FestivalConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionEndDate = {
  __typename?: 'FestivalConnectionEndDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionId = {
  __typename?: 'FestivalConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionInfo = {
  __typename?: 'FestivalConnectionInfo';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionLabel = {
  __typename?: 'FestivalConnectionLabel';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionPlace = {
  __typename?: 'FestivalConnectionPlace';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionPublished_At = {
  __typename?: 'FestivalConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionStartDate = {
  __typename?: 'FestivalConnectionStartDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionTitle = {
  __typename?: 'FestivalConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionUpdated_At = {
  __typename?: 'FestivalConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalConnectionYear = {
  __typename?: 'FestivalConnectionYear';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<FestivalConnection>;
};

export type FestivalGroupBy = {
  __typename?: 'FestivalGroupBy';
  id?: Maybe<Array<Maybe<FestivalConnectionId>>>;
  created_at?: Maybe<Array<Maybe<FestivalConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<FestivalConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<FestivalConnectionTitle>>>;
  place?: Maybe<Array<Maybe<FestivalConnectionPlace>>>;
  coverImage?: Maybe<Array<Maybe<FestivalConnectionCoverImage>>>;
  info?: Maybe<Array<Maybe<FestivalConnectionInfo>>>;
  startDate?: Maybe<Array<Maybe<FestivalConnectionStartDate>>>;
  endDate?: Maybe<Array<Maybe<FestivalConnectionEndDate>>>;
  label?: Maybe<Array<Maybe<FestivalConnectionLabel>>>;
  year?: Maybe<Array<Maybe<FestivalConnectionYear>>>;
  published_at?: Maybe<Array<Maybe<FestivalConnectionPublished_At>>>;
};

export type FestivalInput = {
  title: Scalars['String'];
  place: Scalars['String'];
  coverImage?: Maybe<Scalars['ID']>;
  info: Scalars['String'];
  posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  banners?: Maybe<Array<Maybe<ComponentFestivalBannerInput>>>;
  lineup?: Maybe<Array<Maybe<ComponentFestivalLineupInput>>>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  label?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum FestivalPosition {
  Info = 'INFO',
  InfoBanner_1 = 'INFO_BANNER_1',
  InfoBanner_2 = 'INFO_BANNER_2',
  InfoBanner_3 = 'INFO_BANNER_3',
  Notice = 'NOTICE',
  Contents = 'CONTENTS',
  Lineup = 'LINEUP',
  Extras = 'EXTRAS'
}

export type FileInfoInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type HomePage = {
  __typename?: 'HomePage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  mainTitle?: Maybe<Scalars['String']>;
  mainDescription?: Maybe<Scalars['String']>;
};

export type HomePageInput = {
  mainTitle?: Maybe<Scalars['String']>;
  mainDescription?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type InputId = {
  id: Scalars['ID'];
};


export type LocaleInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};


export type Morph = UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | Category | CategoryConnection | CategoryAggregator | CategoryAggregatorSum | CategoryAggregatorAvg | CategoryAggregatorMin | CategoryAggregatorMax | CategoryGroupBy | CategoryConnectionId | CategoryConnectionCreated_At | CategoryConnectionUpdated_At | CategoryConnectionCategoryId | CategoryConnectionName | CategoryConnectionDescription | CategoryConnectionParent | CategoryConnectionLabel | CategoryConnectionOrder | CreateCategoryPayload | UpdateCategoryPayload | DeleteCategoryPayload | Festival | FestivalConnection | FestivalAggregator | FestivalAggregatorSum | FestivalAggregatorAvg | FestivalAggregatorMin | FestivalAggregatorMax | FestivalGroupBy | FestivalConnectionId | FestivalConnectionCreated_At | FestivalConnectionUpdated_At | FestivalConnectionTitle | FestivalConnectionPlace | FestivalConnectionCoverImage | FestivalConnectionInfo | FestivalConnectionStartDate | FestivalConnectionEndDate | FestivalConnectionLabel | FestivalConnectionYear | FestivalConnectionPublished_At | CreateFestivalPayload | UpdateFestivalPayload | DeleteFestivalPayload | HomePage | UpdateHomePagePayload | DeleteHomePagePayload | Page | PageConnection | PageAggregator | PageGroupBy | PageConnectionId | PageConnectionCreated_At | PageConnectionUpdated_At | PageConnectionPage | PageConnectionDisplayOption | CreatePagePayload | UpdatePagePayload | DeletePagePayload | Post | PostConnection | PostAggregator | PostAggregatorSum | PostAggregatorAvg | PostAggregatorMin | PostAggregatorMax | PostGroupBy | PostConnectionId | PostConnectionCreated_At | PostConnectionUpdated_At | PostConnectionTitle | PostConnectionContent | PostConnectionCategory | PostConnectionCoverImage | PostConnectionDescription | PostConnectionYoutubeUrl | PostConnectionPublishDate | PostConnectionType | PostConnectionOrder | PostConnectionPublished_At | CreatePostPayload | UpdatePostPayload | DeletePostPayload | ShopPage | UpdateShopPagePayload | DeleteShopPagePayload | StaticPage | StaticPageConnection | StaticPageAggregator | StaticPageGroupBy | StaticPageConnectionId | StaticPageConnectionCreated_At | StaticPageConnectionUpdated_At | StaticPageConnectionContent | StaticPageConnectionPath | StaticPageConnectionTitle | StaticPageConnectionPageId | StaticPageConnectionPublished_At | CreateStaticPagePayload | UpdateStaticPagePayload | DeleteStaticPagePayload | Tag | TagConnection | TagAggregator | TagGroupBy | TagConnectionId | TagConnectionCreated_At | TagConnectionUpdated_At | TagConnectionName | TagConnectionSlug | CreateTagPayload | UpdateTagPayload | DeleteTagPayload | I18NLocale | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnectionCreated_At | UploadFileConnectionUpdated_At | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | DeleteFilePayload | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnectionCreated_At | UsersPermissionsUserConnectionUpdated_At | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentFestivalBanners | ComponentFestivalLineup | ComponentMediaImageBanner | ComponentMediaMedia | ComponentPageCategories | ComponentPageDisplayOption | ComponentPostHashTag | ComponentPostRelated | ComponentProgramPlaylist;

export type Mutation = {
  __typename?: 'Mutation';
  createCategory?: Maybe<CreateCategoryPayload>;
  updateCategory?: Maybe<UpdateCategoryPayload>;
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  createFestival?: Maybe<CreateFestivalPayload>;
  updateFestival?: Maybe<UpdateFestivalPayload>;
  deleteFestival?: Maybe<DeleteFestivalPayload>;
  updateHomePage?: Maybe<UpdateHomePagePayload>;
  deleteHomePage?: Maybe<DeleteHomePagePayload>;
  createPage?: Maybe<CreatePagePayload>;
  updatePage?: Maybe<UpdatePagePayload>;
  deletePage?: Maybe<DeletePagePayload>;
  createPost?: Maybe<CreatePostPayload>;
  updatePost?: Maybe<UpdatePostPayload>;
  deletePost?: Maybe<DeletePostPayload>;
  updateShopPage?: Maybe<UpdateShopPagePayload>;
  deleteShopPage?: Maybe<DeleteShopPagePayload>;
  createStaticPage?: Maybe<CreateStaticPagePayload>;
  updateStaticPage?: Maybe<UpdateStaticPagePayload>;
  deleteStaticPage?: Maybe<DeleteStaticPagePayload>;
  createTag?: Maybe<CreateTagPayload>;
  updateTag?: Maybe<UpdateTagPayload>;
  deleteTag?: Maybe<DeleteTagPayload>;
  /** Delete one file */
  deleteFile?: Maybe<DeleteFilePayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  updateFileInfo: UploadFile;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
};


export type MutationCreateCategoryArgs = {
  input?: Maybe<CreateCategoryInput>;
};


export type MutationUpdateCategoryArgs = {
  input?: Maybe<UpdateCategoryInput>;
};


export type MutationDeleteCategoryArgs = {
  input?: Maybe<DeleteCategoryInput>;
};


export type MutationCreateFestivalArgs = {
  input?: Maybe<CreateFestivalInput>;
};


export type MutationUpdateFestivalArgs = {
  input?: Maybe<UpdateFestivalInput>;
};


export type MutationDeleteFestivalArgs = {
  input?: Maybe<DeleteFestivalInput>;
};


export type MutationUpdateHomePageArgs = {
  input?: Maybe<UpdateHomePageInput>;
};


export type MutationCreatePageArgs = {
  input?: Maybe<CreatePageInput>;
};


export type MutationUpdatePageArgs = {
  input?: Maybe<UpdatePageInput>;
};


export type MutationDeletePageArgs = {
  input?: Maybe<DeletePageInput>;
};


export type MutationCreatePostArgs = {
  input?: Maybe<CreatePostInput>;
};


export type MutationUpdatePostArgs = {
  input?: Maybe<UpdatePostInput>;
};


export type MutationDeletePostArgs = {
  input?: Maybe<DeletePostInput>;
};


export type MutationUpdateShopPageArgs = {
  input?: Maybe<UpdateShopPageInput>;
};


export type MutationCreateStaticPageArgs = {
  input?: Maybe<CreateStaticPageInput>;
};


export type MutationUpdateStaticPageArgs = {
  input?: Maybe<UpdateStaticPageInput>;
};


export type MutationDeleteStaticPageArgs = {
  input?: Maybe<DeleteStaticPageInput>;
};


export type MutationCreateTagArgs = {
  input?: Maybe<CreateTagInput>;
};


export type MutationUpdateTagArgs = {
  input?: Maybe<UpdateTagInput>;
};


export type MutationDeleteTagArgs = {
  input?: Maybe<DeleteTagInput>;
};


export type MutationDeleteFileArgs = {
  input?: Maybe<DeleteFileInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  info?: Maybe<FileInfoInput>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info: FileInfoInput;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};

export type Page = {
  __typename?: 'Page';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  page: PageId;
  banners?: Maybe<Array<Maybe<ComponentMediaMedia>>>;
  displayOption?: Maybe<ComponentPageDisplayOption>;
  categories?: Maybe<Array<Maybe<ComponentPageCategories>>>;
};

export type PageAggregator = {
  __typename?: 'PageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PageConnection = {
  __typename?: 'PageConnection';
  values?: Maybe<Array<Maybe<Page>>>;
  groupBy?: Maybe<PageGroupBy>;
  aggregate?: Maybe<PageAggregator>;
};

export type PageConnectionCreated_At = {
  __typename?: 'PageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PageConnection>;
};

export type PageConnectionDisplayOption = {
  __typename?: 'PageConnectionDisplayOption';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PageConnection>;
};

export type PageConnectionId = {
  __typename?: 'PageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PageConnection>;
};

export type PageConnectionPage = {
  __typename?: 'PageConnectionPage';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PageConnection>;
};

export type PageConnectionUpdated_At = {
  __typename?: 'PageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PageConnection>;
};

export type PageGroupBy = {
  __typename?: 'PageGroupBy';
  id?: Maybe<Array<Maybe<PageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PageConnectionUpdated_At>>>;
  page?: Maybe<Array<Maybe<PageConnectionPage>>>;
  displayOption?: Maybe<Array<Maybe<PageConnectionDisplayOption>>>;
};

export enum PageId {
  Main = 'MAIN',
  Mintplus = 'MINTPLUS',
  Connect = 'CONNECT',
  Originals = 'ORIGINALS',
  Search = 'SEARCH'
}

export type PageInput = {
  page: PageId;
  banners?: Maybe<Array<Maybe<ComponentMediaMediaInput>>>;
  displayOption?: Maybe<ComponentPageDisplayOptionInput>;
  categories?: Maybe<Array<Maybe<ComponentPageCategoryInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Post = {
  __typename?: 'Post';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  title: Scalars['String'];
  content: Scalars['String'];
  category?: Maybe<Category>;
  coverImage?: Maybe<UploadFile>;
  description?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  type: PostType;
  related?: Maybe<Array<Maybe<ComponentPostRelated>>>;
  tagsInput?: Maybe<Array<Maybe<ComponentPostHashTag>>>;
  order?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  festivals?: Maybe<Array<Maybe<Festival>>>;
};


export type PostTagsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type PostFestivalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type PostAggregator = {
  __typename?: 'PostAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<PostAggregatorSum>;
  avg?: Maybe<PostAggregatorAvg>;
  min?: Maybe<PostAggregatorMin>;
  max?: Maybe<PostAggregatorMax>;
};

export type PostAggregatorAvg = {
  __typename?: 'PostAggregatorAvg';
  order?: Maybe<Scalars['Float']>;
};

export type PostAggregatorMax = {
  __typename?: 'PostAggregatorMax';
  order?: Maybe<Scalars['Float']>;
};

export type PostAggregatorMin = {
  __typename?: 'PostAggregatorMin';
  order?: Maybe<Scalars['Float']>;
};

export type PostAggregatorSum = {
  __typename?: 'PostAggregatorSum';
  order?: Maybe<Scalars['Float']>;
};

export type PostConnection = {
  __typename?: 'PostConnection';
  values?: Maybe<Array<Maybe<Post>>>;
  groupBy?: Maybe<PostGroupBy>;
  aggregate?: Maybe<PostAggregator>;
};

export type PostConnectionCategory = {
  __typename?: 'PostConnectionCategory';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionContent = {
  __typename?: 'PostConnectionContent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionCoverImage = {
  __typename?: 'PostConnectionCoverImage';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionCreated_At = {
  __typename?: 'PostConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionDescription = {
  __typename?: 'PostConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionId = {
  __typename?: 'PostConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionOrder = {
  __typename?: 'PostConnectionOrder';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionPublishDate = {
  __typename?: 'PostConnectionPublishDate';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionPublished_At = {
  __typename?: 'PostConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionTitle = {
  __typename?: 'PostConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionType = {
  __typename?: 'PostConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionUpdated_At = {
  __typename?: 'PostConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PostConnection>;
};

export type PostConnectionYoutubeUrl = {
  __typename?: 'PostConnectionYoutubeUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PostConnection>;
};

export type PostGroupBy = {
  __typename?: 'PostGroupBy';
  id?: Maybe<Array<Maybe<PostConnectionId>>>;
  created_at?: Maybe<Array<Maybe<PostConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<PostConnectionUpdated_At>>>;
  title?: Maybe<Array<Maybe<PostConnectionTitle>>>;
  content?: Maybe<Array<Maybe<PostConnectionContent>>>;
  category?: Maybe<Array<Maybe<PostConnectionCategory>>>;
  coverImage?: Maybe<Array<Maybe<PostConnectionCoverImage>>>;
  description?: Maybe<Array<Maybe<PostConnectionDescription>>>;
  youtubeUrl?: Maybe<Array<Maybe<PostConnectionYoutubeUrl>>>;
  publishDate?: Maybe<Array<Maybe<PostConnectionPublishDate>>>;
  type?: Maybe<Array<Maybe<PostConnectionType>>>;
  order?: Maybe<Array<Maybe<PostConnectionOrder>>>;
  published_at?: Maybe<Array<Maybe<PostConnectionPublished_At>>>;
};

export type PostInput = {
  title: Scalars['String'];
  content: Scalars['String'];
  category?: Maybe<Scalars['ID']>;
  coverImage?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<PostType>;
  related?: Maybe<Array<Maybe<ComponentPostRelatedInput>>>;
  festivals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tagsInput?: Maybe<Array<Maybe<ComponentPostHashTagInput>>>;
  order?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export enum PostType {
  Normal = 'NORMAL',
  YoutubeExternal = 'YOUTUBE_EXTERNAL',
  Program = 'PROGRAM'
}

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  category?: Maybe<Category>;
  categories?: Maybe<Array<Maybe<Category>>>;
  categoriesConnection?: Maybe<CategoryConnection>;
  festival?: Maybe<Festival>;
  festivals?: Maybe<Array<Maybe<Festival>>>;
  festivalsConnection?: Maybe<FestivalConnection>;
  homePage?: Maybe<HomePage>;
  page?: Maybe<Page>;
  pages?: Maybe<Array<Maybe<Page>>>;
  pagesConnection?: Maybe<PageConnection>;
  post?: Maybe<Post>;
  posts?: Maybe<Array<Maybe<Post>>>;
  postsConnection?: Maybe<PostConnection>;
  shopPage?: Maybe<ShopPage>;
  staticPage?: Maybe<StaticPage>;
  staticPages?: Maybe<Array<Maybe<StaticPage>>>;
  staticPagesConnection?: Maybe<StaticPageConnection>;
  tag?: Maybe<Tag>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  tagsConnection?: Maybe<TagConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  me?: Maybe<UsersPermissionsMe>;
};


export type QueryCategoryArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryCategoriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFestivalArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryFestivalsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFestivalsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryHomePageArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryPageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPostArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryPostsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryPostsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryShopPageArgs = {
  publicationState?: Maybe<PublicationState>;
};


export type QueryStaticPageArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryStaticPagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryStaticPagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryTagArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryTagsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryTagsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
  publicationState?: Maybe<PublicationState>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ShopPage = {
  __typename?: 'ShopPage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  link?: Maybe<Scalars['String']>;
};

export type ShopPageInput = {
  link?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type StaticPage = {
  __typename?: 'StaticPage';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  content: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
  pageId?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
};

export type StaticPageAggregator = {
  __typename?: 'StaticPageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type StaticPageConnection = {
  __typename?: 'StaticPageConnection';
  values?: Maybe<Array<Maybe<StaticPage>>>;
  groupBy?: Maybe<StaticPageGroupBy>;
  aggregate?: Maybe<StaticPageAggregator>;
};

export type StaticPageConnectionContent = {
  __typename?: 'StaticPageConnectionContent';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionCreated_At = {
  __typename?: 'StaticPageConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionId = {
  __typename?: 'StaticPageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionPageId = {
  __typename?: 'StaticPageConnectionPageId';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionPath = {
  __typename?: 'StaticPageConnectionPath';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionPublished_At = {
  __typename?: 'StaticPageConnectionPublished_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionTitle = {
  __typename?: 'StaticPageConnectionTitle';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageConnectionUpdated_At = {
  __typename?: 'StaticPageConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<StaticPageConnection>;
};

export type StaticPageGroupBy = {
  __typename?: 'StaticPageGroupBy';
  id?: Maybe<Array<Maybe<StaticPageConnectionId>>>;
  created_at?: Maybe<Array<Maybe<StaticPageConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<StaticPageConnectionUpdated_At>>>;
  content?: Maybe<Array<Maybe<StaticPageConnectionContent>>>;
  path?: Maybe<Array<Maybe<StaticPageConnectionPath>>>;
  title?: Maybe<Array<Maybe<StaticPageConnectionTitle>>>;
  pageId?: Maybe<Array<Maybe<StaticPageConnectionPageId>>>;
  published_at?: Maybe<Array<Maybe<StaticPageConnectionPublished_At>>>;
};

export type StaticPageInput = {
  content: Scalars['String'];
  path: Scalars['String'];
  title: Scalars['String'];
  pageId?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
};

export type TagAggregator = {
  __typename?: 'TagAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TagConnection = {
  __typename?: 'TagConnection';
  values?: Maybe<Array<Maybe<Tag>>>;
  groupBy?: Maybe<TagGroupBy>;
  aggregate?: Maybe<TagAggregator>;
};

export type TagConnectionCreated_At = {
  __typename?: 'TagConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TagConnection>;
};

export type TagConnectionId = {
  __typename?: 'TagConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<TagConnection>;
};

export type TagConnectionName = {
  __typename?: 'TagConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TagConnection>;
};

export type TagConnectionSlug = {
  __typename?: 'TagConnectionSlug';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<TagConnection>;
};

export type TagConnectionUpdated_At = {
  __typename?: 'TagConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<TagConnection>;
};

export type TagGroupBy = {
  __typename?: 'TagGroupBy';
  id?: Maybe<Array<Maybe<TagConnectionId>>>;
  created_at?: Maybe<Array<Maybe<TagConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<TagConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<TagConnectionName>>>;
  slug?: Maybe<Array<Maybe<TagConnectionSlug>>>;
};

export type TagInput = {
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};



export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_At = {
  __typename?: 'UploadFileConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_At = {
  __typename?: 'UploadFileConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UploadFileConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UploadFileConnectionUpdated_At>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  created_at: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_At = {
  __typename?: 'UsersPermissionsUserConnectionCreated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_At = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_at';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  created_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_At>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
};

export type CreateCategoryInput = {
  data?: Maybe<CategoryInput>;
};

export type CreateCategoryPayload = {
  __typename?: 'createCategoryPayload';
  category?: Maybe<Category>;
};

export type CreateFestivalInput = {
  data?: Maybe<FestivalInput>;
};

export type CreateFestivalPayload = {
  __typename?: 'createFestivalPayload';
  festival?: Maybe<Festival>;
};

export type CreatePageInput = {
  data?: Maybe<PageInput>;
};

export type CreatePagePayload = {
  __typename?: 'createPagePayload';
  page?: Maybe<Page>;
};

export type CreatePostInput = {
  data?: Maybe<PostInput>;
};

export type CreatePostPayload = {
  __typename?: 'createPostPayload';
  post?: Maybe<Post>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type CreateStaticPageInput = {
  data?: Maybe<StaticPageInput>;
};

export type CreateStaticPagePayload = {
  __typename?: 'createStaticPagePayload';
  staticPage?: Maybe<StaticPage>;
};

export type CreateTagInput = {
  data?: Maybe<TagInput>;
};

export type CreateTagPayload = {
  __typename?: 'createTagPayload';
  tag?: Maybe<Tag>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteCategoryInput = {
  where?: Maybe<InputId>;
};

export type DeleteCategoryPayload = {
  __typename?: 'deleteCategoryPayload';
  category?: Maybe<Category>;
};

export type DeleteFestivalInput = {
  where?: Maybe<InputId>;
};

export type DeleteFestivalPayload = {
  __typename?: 'deleteFestivalPayload';
  festival?: Maybe<Festival>;
};

export type DeleteFileInput = {
  where?: Maybe<InputId>;
};

export type DeleteFilePayload = {
  __typename?: 'deleteFilePayload';
  file?: Maybe<UploadFile>;
};

export type DeleteHomePagePayload = {
  __typename?: 'deleteHomePagePayload';
  homePage?: Maybe<HomePage>;
};

export type DeletePageInput = {
  where?: Maybe<InputId>;
};

export type DeletePagePayload = {
  __typename?: 'deletePagePayload';
  page?: Maybe<Page>;
};

export type DeletePostInput = {
  where?: Maybe<InputId>;
};

export type DeletePostPayload = {
  __typename?: 'deletePostPayload';
  post?: Maybe<Post>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteShopPagePayload = {
  __typename?: 'deleteShopPagePayload';
  shopPage?: Maybe<ShopPage>;
};

export type DeleteStaticPageInput = {
  where?: Maybe<InputId>;
};

export type DeleteStaticPagePayload = {
  __typename?: 'deleteStaticPagePayload';
  staticPage?: Maybe<StaticPage>;
};

export type DeleteTagInput = {
  where?: Maybe<InputId>;
};

export type DeleteTagPayload = {
  __typename?: 'deleteTagPayload';
  tag?: Maybe<Tag>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type EditCategoryInput = {
  categoryId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  parent?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentFestivalBannerInput = {
  id?: Maybe<Scalars['ID']>;
  position?: Maybe<FestivalPosition>;
  banner?: Maybe<Array<Maybe<EditComponentMediaMediaInput>>>;
  label?: Maybe<Scalars['String']>;
};

export type EditComponentFestivalLineupInput = {
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  banners?: Maybe<Array<Maybe<EditComponentMediaImageBannerInput>>>;
};

export type EditComponentMediaImageBannerInput = {
  id?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type EditComponentMediaMediaInput = {
  id?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  media?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type EditComponentPageCategoryInput = {
  id?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type EditComponentPageDisplayOptionInput = {
  id?: Maybe<Scalars['ID']>;
  pc?: Maybe<Scalars['Int']>;
  mobile?: Maybe<Scalars['Int']>;
  categoryLimit?: Maybe<Scalars['Int']>;
};

export type EditComponentPostHashTagInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type EditComponentPostRelatedInput = {
  id?: Maybe<Scalars['ID']>;
  post?: Maybe<Scalars['ID']>;
  memo?: Maybe<Scalars['String']>;
};

export type EditComponentProgramPlaylistInput = {
  id?: Maybe<Scalars['ID']>;
};

export type EditFestivalInput = {
  title?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Scalars['ID']>;
  info?: Maybe<Scalars['String']>;
  posts?: Maybe<Array<Maybe<Scalars['ID']>>>;
  banners?: Maybe<Array<Maybe<EditComponentFestivalBannerInput>>>;
  lineup?: Maybe<Array<Maybe<EditComponentFestivalLineupInput>>>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  label?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditHomePageInput = {
  mainTitle?: Maybe<Scalars['String']>;
  mainDescription?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditLocaleInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPageInput = {
  page?: Maybe<PageId>;
  banners?: Maybe<Array<Maybe<EditComponentMediaMediaInput>>>;
  displayOption?: Maybe<EditComponentPageDisplayOptionInput>;
  categories?: Maybe<Array<Maybe<EditComponentPageCategoryInput>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditPostInput = {
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['ID']>;
  coverImage?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Maybe<Scalars['ID']>>>;
  description?: Maybe<Scalars['String']>;
  youtubeUrl?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  type?: Maybe<PostType>;
  related?: Maybe<Array<Maybe<EditComponentPostRelatedInput>>>;
  festivals?: Maybe<Array<Maybe<Scalars['ID']>>>;
  tagsInput?: Maybe<Array<Maybe<EditComponentPostHashTagInput>>>;
  order?: Maybe<Scalars['Int']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditShopPageInput = {
  link?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditStaticPageInput = {
  content?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  pageId?: Maybe<Scalars['String']>;
  published_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditTagInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCategoryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCategoryInput>;
};

export type UpdateCategoryPayload = {
  __typename?: 'updateCategoryPayload';
  category?: Maybe<Category>;
};

export type UpdateFestivalInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditFestivalInput>;
};

export type UpdateFestivalPayload = {
  __typename?: 'updateFestivalPayload';
  festival?: Maybe<Festival>;
};

export type UpdateHomePageInput = {
  data?: Maybe<EditHomePageInput>;
};

export type UpdateHomePagePayload = {
  __typename?: 'updateHomePagePayload';
  homePage?: Maybe<HomePage>;
};

export type UpdatePageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPageInput>;
};

export type UpdatePagePayload = {
  __typename?: 'updatePagePayload';
  page?: Maybe<Page>;
};

export type UpdatePostInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPostInput>;
};

export type UpdatePostPayload = {
  __typename?: 'updatePostPayload';
  post?: Maybe<Post>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateShopPageInput = {
  data?: Maybe<EditShopPageInput>;
};

export type UpdateShopPagePayload = {
  __typename?: 'updateShopPagePayload';
  shopPage?: Maybe<ShopPage>;
};

export type UpdateStaticPageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditStaticPageInput>;
};

export type UpdateStaticPagePayload = {
  __typename?: 'updateStaticPagePayload';
  staticPage?: Maybe<StaticPage>;
};

export type UpdateTagInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditTagInput>;
};

export type UpdateTagPayload = {
  __typename?: 'updateTagPayload';
  tag?: Maybe<Tag>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = (
  { __typename?: 'Query' }
  & { categories?: Maybe<Array<Maybe<(
    { __typename?: 'Category' }
    & CategoryItemFragment
  )>>> }
);

export type FestivalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FestivalQuery = (
  { __typename?: 'Query' }
  & { festival?: Maybe<(
    { __typename?: 'Festival' }
    & Pick<Festival, 'id' | 'title' | 'place' | 'startDate' | 'endDate' | 'info'>
    & { coverImage?: Maybe<(
      { __typename?: 'UploadFile' }
      & Pick<UploadFile, 'id' | 'url'>
    )>, lineup?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentFestivalLineup' }
      & Pick<ComponentFestivalLineup, 'title'>
      & { banners?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentMediaImageBanner' }
        & Pick<ComponentMediaImageBanner, 'title' | 'description' | 'link'>
        & { image?: Maybe<(
          { __typename?: 'UploadFile' }
          & SimpleMediaItemFragment
        )> }
      )>>> }
    )>>>, banners?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentFestivalBanners' }
      & Pick<ComponentFestivalBanners, 'position'>
      & { banner?: Maybe<Array<Maybe<(
        { __typename?: 'ComponentMediaMedia' }
        & Pick<ComponentMediaMedia, 'id' | 'link'>
        & { media?: Maybe<(
          { __typename?: 'UploadFile' }
          & SimpleMediaItemFragment
        )> }
      )>>> }
    )>>> }
  )> }
);

export type FestivalsQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type FestivalsQuery = (
  { __typename?: 'Query' }
  & { festivals?: Maybe<Array<Maybe<(
    { __typename?: 'Festival' }
    & Pick<Festival, 'id' | 'title' | 'place' | 'startDate' | 'endDate'>
    & { coverImage?: Maybe<(
      { __typename?: 'UploadFile' }
      & SimpleMediaItemFragment
    )> }
  )>>> }
);

export type FestivalYearsQueryVariables = Exact<{ [key: string]: never; }>;


export type FestivalYearsQuery = (
  { __typename?: 'Query' }
  & { festivalsConnection?: Maybe<(
    { __typename?: 'FestivalConnection' }
    & { groupBy?: Maybe<(
      { __typename?: 'FestivalGroupBy' }
      & { year?: Maybe<Array<Maybe<(
        { __typename?: 'FestivalConnectionYear' }
        & Pick<FestivalConnectionYear, 'key'>
      )>>> }
    )> }
  )> }
);

export type CategoryItemFragment = (
  { __typename?: 'Category' }
  & Pick<Category, 'categoryId' | 'name' | 'description' | 'parent' | 'order'>
);

export type SimpleMediaItemFragment = (
  { __typename?: 'UploadFile' }
  & Pick<UploadFile, 'id' | 'url' | 'mime' | 'formats'>
);

export type PostItemFragment = (
  { __typename?: 'Post' }
  & Pick<Post, 'id' | 'title' | 'description' | 'youtubeUrl' | 'type' | 'created_at' | 'updated_at' | 'published_at' | 'publishDate' | 'order'>
  & { coverImage?: Maybe<(
    { __typename?: 'UploadFile' }
    & SimpleMediaItemFragment
  )> }
);

export type HomePageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageDataQuery = (
  { __typename?: 'Query' }
  & { homePage?: Maybe<(
    { __typename?: 'HomePage' }
    & Pick<HomePage, 'mainTitle' | 'mainDescription'>
  )> }
);

export type PageDataQueryVariables = Exact<{
  page: Scalars['String'];
}>;


export type PageDataQuery = (
  { __typename?: 'Query' }
  & { pages?: Maybe<Array<Maybe<(
    { __typename?: 'Page' }
    & Pick<Page, 'id' | 'page'>
    & { banners?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentMediaMedia' }
      & Pick<ComponentMediaMedia, 'id' | 'link'>
      & { media?: Maybe<(
        { __typename?: 'UploadFile' }
        & SimpleMediaItemFragment
      )> }
    )>>>, displayOption?: Maybe<(
      { __typename?: 'ComponentPageDisplayOption' }
      & Pick<ComponentPageDisplayOption, 'id' | 'pc' | 'mobile' | 'categoryLimit'>
    )>, categories?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentPageCategories' }
      & { category?: Maybe<(
        { __typename?: 'Category' }
        & CategoryItemFragment
      )> }
    )>>> }
  )>>> }
);

export type PostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PostQuery = (
  { __typename?: 'Query' }
  & { post?: Maybe<(
    { __typename?: 'Post' }
    & Pick<Post, 'content'>
    & { category?: Maybe<(
      { __typename?: 'Category' }
      & Pick<Category, 'categoryId'>
    )>, tags?: Maybe<Array<Maybe<(
      { __typename?: 'Tag' }
      & Pick<Tag, 'id' | 'name' | 'slug'>
    )>>>, related?: Maybe<Array<Maybe<(
      { __typename?: 'ComponentPostRelated' }
      & { post?: Maybe<(
        { __typename?: 'Post' }
        & PostItemFragment
      )> }
    )>>> }
    & PostItemFragment
  )> }
);

export type PostsConnectionQueryVariables = Exact<{
  where: Scalars['JSON'];
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type PostsConnectionQuery = (
  { __typename?: 'Query' }
  & { postsConnection?: Maybe<(
    { __typename?: 'PostConnection' }
    & { values?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & PostItemFragment
    )>>>, aggregate?: Maybe<(
      { __typename?: 'PostAggregator' }
      & Pick<PostAggregator, 'count'>
    )> }
  )> }
);

export type PostsQueryVariables = Exact<{
  where: Scalars['JSON'];
  start?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type PostsQuery = (
  { __typename?: 'Query' }
  & { posts?: Maybe<Array<Maybe<(
    { __typename?: 'Post' }
    & PostItemFragment
  )>>> }
);

export type PostCountQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type PostCountQuery = (
  { __typename?: 'Query' }
  & { postsConnection?: Maybe<(
    { __typename?: 'PostConnection' }
    & { aggregate?: Maybe<(
      { __typename?: 'PostAggregator' }
      & Pick<PostAggregator, 'count'>
    )> }
  )> }
);

export type PostPrevNextQueryVariables = Exact<{
  prevWhere: Scalars['JSON'];
  nextWhere: Scalars['JSON'];
}>;


export type PostPrevNextQuery = (
  { __typename?: 'Query' }
  & { prev?: Maybe<(
    { __typename?: 'PostConnection' }
    & { values?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'id'>
    )>>> }
  )>, next?: Maybe<(
    { __typename?: 'PostConnection' }
    & { values?: Maybe<Array<Maybe<(
      { __typename?: 'Post' }
      & Pick<Post, 'id'>
    )>>> }
  )> }
);

export type ShopPageLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopPageLinkQuery = (
  { __typename?: 'Query' }
  & { shopPage?: Maybe<(
    { __typename?: 'ShopPage' }
    & Pick<ShopPage, 'link'>
  )> }
);

export type StaticPageQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type StaticPageQuery = (
  { __typename?: 'Query' }
  & { staticPages?: Maybe<Array<Maybe<(
    { __typename?: 'StaticPage' }
    & Pick<StaticPage, 'pageId' | 'title' | 'path' | 'content'>
  )>>> }
);

export type TagsQueryVariables = Exact<{
  where: Scalars['JSON'];
}>;


export type TagsQuery = (
  { __typename?: 'Query' }
  & { tags?: Maybe<Array<Maybe<(
    { __typename?: 'Tag' }
    & Pick<Tag, 'id' | 'name' | 'slug'>
  )>>> }
);

export const CategoryItemFragmentDoc = gql`
    fragment CategoryItem on Category {
  categoryId
  name
  description
  parent
  order
}
    `;
export const SimpleMediaItemFragmentDoc = gql`
    fragment SimpleMediaItem on UploadFile {
  id
  url
  mime
  formats
}
    `;
export const PostItemFragmentDoc = gql`
    fragment PostItem on Post {
  id
  title
  description
  youtubeUrl
  coverImage {
    ...SimpleMediaItem
  }
  type
  created_at
  updated_at
  published_at
  publishDate
  order
}
    ${SimpleMediaItemFragmentDoc}`;
export const CategoriesDocument = gql`
    query categories {
  categories(sort: "order:asc") {
    ...CategoryItem
  }
}
    ${CategoryItemFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const FestivalDocument = gql`
    query festival($id: ID!) {
  festival(id: $id) {
    id
    title
    place
    startDate
    endDate
    info
    coverImage {
      id
      url
    }
    lineup {
      title
      banners {
        title
        description
        link
        image {
          ...SimpleMediaItem
        }
      }
    }
    banners {
      position
      banner {
        id
        link
        media {
          ...SimpleMediaItem
        }
      }
    }
  }
}
    ${SimpleMediaItemFragmentDoc}`;

/**
 * __useFestivalQuery__
 *
 * To run a query within a React component, call `useFestivalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFestivalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFestivalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFestivalQuery(baseOptions: Apollo.QueryHookOptions<FestivalQuery, FestivalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FestivalQuery, FestivalQueryVariables>(FestivalDocument, options);
      }
export function useFestivalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FestivalQuery, FestivalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FestivalQuery, FestivalQueryVariables>(FestivalDocument, options);
        }
export type FestivalQueryHookResult = ReturnType<typeof useFestivalQuery>;
export type FestivalLazyQueryHookResult = ReturnType<typeof useFestivalLazyQuery>;
export type FestivalQueryResult = Apollo.QueryResult<FestivalQuery, FestivalQueryVariables>;
export const FestivalsDocument = gql`
    query festivals($year: Int!) {
  festivals(sort: "startDate:desc", where: {year: $year}) {
    id
    title
    place
    startDate
    endDate
    coverImage {
      ...SimpleMediaItem
    }
  }
}
    ${SimpleMediaItemFragmentDoc}`;

/**
 * __useFestivalsQuery__
 *
 * To run a query within a React component, call `useFestivalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFestivalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFestivalsQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useFestivalsQuery(baseOptions: Apollo.QueryHookOptions<FestivalsQuery, FestivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FestivalsQuery, FestivalsQueryVariables>(FestivalsDocument, options);
      }
export function useFestivalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FestivalsQuery, FestivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FestivalsQuery, FestivalsQueryVariables>(FestivalsDocument, options);
        }
export type FestivalsQueryHookResult = ReturnType<typeof useFestivalsQuery>;
export type FestivalsLazyQueryHookResult = ReturnType<typeof useFestivalsLazyQuery>;
export type FestivalsQueryResult = Apollo.QueryResult<FestivalsQuery, FestivalsQueryVariables>;
export const FestivalYearsDocument = gql`
    query festivalYears {
  festivalsConnection {
    groupBy {
      year {
        key
      }
    }
  }
}
    `;

/**
 * __useFestivalYearsQuery__
 *
 * To run a query within a React component, call `useFestivalYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFestivalYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFestivalYearsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFestivalYearsQuery(baseOptions?: Apollo.QueryHookOptions<FestivalYearsQuery, FestivalYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FestivalYearsQuery, FestivalYearsQueryVariables>(FestivalYearsDocument, options);
      }
export function useFestivalYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FestivalYearsQuery, FestivalYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FestivalYearsQuery, FestivalYearsQueryVariables>(FestivalYearsDocument, options);
        }
export type FestivalYearsQueryHookResult = ReturnType<typeof useFestivalYearsQuery>;
export type FestivalYearsLazyQueryHookResult = ReturnType<typeof useFestivalYearsLazyQuery>;
export type FestivalYearsQueryResult = Apollo.QueryResult<FestivalYearsQuery, FestivalYearsQueryVariables>;
export const HomePageDataDocument = gql`
    query homePageData {
  homePage {
    mainTitle
    mainDescription
  }
}
    `;

/**
 * __useHomePageDataQuery__
 *
 * To run a query within a React component, call `useHomePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageDataQuery(baseOptions?: Apollo.QueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageDataQuery, HomePageDataQueryVariables>(HomePageDataDocument, options);
      }
export function useHomePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageDataQuery, HomePageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageDataQuery, HomePageDataQueryVariables>(HomePageDataDocument, options);
        }
export type HomePageDataQueryHookResult = ReturnType<typeof useHomePageDataQuery>;
export type HomePageDataLazyQueryHookResult = ReturnType<typeof useHomePageDataLazyQuery>;
export type HomePageDataQueryResult = Apollo.QueryResult<HomePageDataQuery, HomePageDataQueryVariables>;
export const PageDataDocument = gql`
    query pageData($page: String!) {
  pages(where: {page: $page}) {
    id
    page
    banners {
      id
      link
      media {
        ...SimpleMediaItem
      }
    }
    displayOption {
      id
      pc
      mobile
      categoryLimit
    }
    categories {
      category {
        ...CategoryItem
      }
    }
  }
}
    ${SimpleMediaItemFragmentDoc}
${CategoryItemFragmentDoc}`;

/**
 * __usePageDataQuery__
 *
 * To run a query within a React component, call `usePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageDataQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePageDataQuery(baseOptions: Apollo.QueryHookOptions<PageDataQuery, PageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageDataQuery, PageDataQueryVariables>(PageDataDocument, options);
      }
export function usePageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageDataQuery, PageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageDataQuery, PageDataQueryVariables>(PageDataDocument, options);
        }
export type PageDataQueryHookResult = ReturnType<typeof usePageDataQuery>;
export type PageDataLazyQueryHookResult = ReturnType<typeof usePageDataLazyQuery>;
export type PageDataQueryResult = Apollo.QueryResult<PageDataQuery, PageDataQueryVariables>;
export const PostDocument = gql`
    query post($id: ID!) {
  post(id: $id) {
    ...PostItem
    content
    category {
      categoryId
    }
    tags {
      id
      name
      slug
    }
    related {
      post {
        ...PostItem
      }
    }
  }
}
    ${PostItemFragmentDoc}`;

/**
 * __usePostQuery__
 *
 * To run a query within a React component, call `usePostQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostQuery(baseOptions: Apollo.QueryHookOptions<PostQuery, PostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostQuery, PostQueryVariables>(PostDocument, options);
      }
export function usePostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostQuery, PostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostQuery, PostQueryVariables>(PostDocument, options);
        }
export type PostQueryHookResult = ReturnType<typeof usePostQuery>;
export type PostLazyQueryHookResult = ReturnType<typeof usePostLazyQuery>;
export type PostQueryResult = Apollo.QueryResult<PostQuery, PostQueryVariables>;
export const PostsConnectionDocument = gql`
    query postsConnection($where: JSON!, $start: Int, $limit: Int) {
  postsConnection(
    where: $where
    sort: "order:asc,publishDate:desc,id:asc"
    start: $start
    limit: $limit
  ) {
    values {
      ...PostItem
    }
    aggregate {
      count
    }
  }
}
    ${PostItemFragmentDoc}`;

/**
 * __usePostsConnectionQuery__
 *
 * To run a query within a React component, call `usePostsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsConnectionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePostsConnectionQuery(baseOptions: Apollo.QueryHookOptions<PostsConnectionQuery, PostsConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsConnectionQuery, PostsConnectionQueryVariables>(PostsConnectionDocument, options);
      }
export function usePostsConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsConnectionQuery, PostsConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsConnectionQuery, PostsConnectionQueryVariables>(PostsConnectionDocument, options);
        }
export type PostsConnectionQueryHookResult = ReturnType<typeof usePostsConnectionQuery>;
export type PostsConnectionLazyQueryHookResult = ReturnType<typeof usePostsConnectionLazyQuery>;
export type PostsConnectionQueryResult = Apollo.QueryResult<PostsConnectionQuery, PostsConnectionQueryVariables>;
export const PostsDocument = gql`
    query posts($where: JSON!, $start: Int, $limit: Int) {
  posts(
    where: $where
    sort: "order:asc,publishDate:desc,id:asc"
    start: $start
    limit: $limit
  ) {
    ...PostItem
  }
}
    ${PostItemFragmentDoc}`;

/**
 * __usePostsQuery__
 *
 * To run a query within a React component, call `usePostsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePostsQuery(baseOptions: Apollo.QueryHookOptions<PostsQuery, PostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
      }
export function usePostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsQuery, PostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsQuery, PostsQueryVariables>(PostsDocument, options);
        }
export type PostsQueryHookResult = ReturnType<typeof usePostsQuery>;
export type PostsLazyQueryHookResult = ReturnType<typeof usePostsLazyQuery>;
export type PostsQueryResult = Apollo.QueryResult<PostsQuery, PostsQueryVariables>;
export const PostCountDocument = gql`
    query postCount($where: JSON!) {
  postsConnection(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __usePostCountQuery__
 *
 * To run a query within a React component, call `usePostCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePostCountQuery(baseOptions: Apollo.QueryHookOptions<PostCountQuery, PostCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
      }
export function usePostCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCountQuery, PostCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCountQuery, PostCountQueryVariables>(PostCountDocument, options);
        }
export type PostCountQueryHookResult = ReturnType<typeof usePostCountQuery>;
export type PostCountLazyQueryHookResult = ReturnType<typeof usePostCountLazyQuery>;
export type PostCountQueryResult = Apollo.QueryResult<PostCountQuery, PostCountQueryVariables>;
export const PostPrevNextDocument = gql`
    query postPrevNext($prevWhere: JSON!, $nextWhere: JSON!) {
  prev: postsConnection(
    where: $prevWhere
    sort: "order:asc,publishDate:asc,id:desc"
    limit: 1
  ) {
    values {
      id
    }
  }
  next: postsConnection(
    where: $nextWhere
    sort: "order:asc,publishDate:desc,id:asc"
    limit: 1
  ) {
    values {
      id
    }
  }
}
    `;

/**
 * __usePostPrevNextQuery__
 *
 * To run a query within a React component, call `usePostPrevNextQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostPrevNextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostPrevNextQuery({
 *   variables: {
 *      prevWhere: // value for 'prevWhere'
 *      nextWhere: // value for 'nextWhere'
 *   },
 * });
 */
export function usePostPrevNextQuery(baseOptions: Apollo.QueryHookOptions<PostPrevNextQuery, PostPrevNextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostPrevNextQuery, PostPrevNextQueryVariables>(PostPrevNextDocument, options);
      }
export function usePostPrevNextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostPrevNextQuery, PostPrevNextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostPrevNextQuery, PostPrevNextQueryVariables>(PostPrevNextDocument, options);
        }
export type PostPrevNextQueryHookResult = ReturnType<typeof usePostPrevNextQuery>;
export type PostPrevNextLazyQueryHookResult = ReturnType<typeof usePostPrevNextLazyQuery>;
export type PostPrevNextQueryResult = Apollo.QueryResult<PostPrevNextQuery, PostPrevNextQueryVariables>;
export const ShopPageLinkDocument = gql`
    query ShopPageLink {
  shopPage {
    link
  }
}
    `;

/**
 * __useShopPageLinkQuery__
 *
 * To run a query within a React component, call `useShopPageLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopPageLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopPageLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useShopPageLinkQuery(baseOptions?: Apollo.QueryHookOptions<ShopPageLinkQuery, ShopPageLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopPageLinkQuery, ShopPageLinkQueryVariables>(ShopPageLinkDocument, options);
      }
export function useShopPageLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopPageLinkQuery, ShopPageLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopPageLinkQuery, ShopPageLinkQueryVariables>(ShopPageLinkDocument, options);
        }
export type ShopPageLinkQueryHookResult = ReturnType<typeof useShopPageLinkQuery>;
export type ShopPageLinkLazyQueryHookResult = ReturnType<typeof useShopPageLinkLazyQuery>;
export type ShopPageLinkQueryResult = Apollo.QueryResult<ShopPageLinkQuery, ShopPageLinkQueryVariables>;
export const StaticPageDocument = gql`
    query staticPage($where: JSON!) {
  staticPages(where: $where) {
    pageId
    title
    path
    content
  }
}
    `;

/**
 * __useStaticPageQuery__
 *
 * To run a query within a React component, call `useStaticPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaticPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaticPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useStaticPageQuery(baseOptions: Apollo.QueryHookOptions<StaticPageQuery, StaticPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, options);
      }
export function useStaticPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StaticPageQuery, StaticPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StaticPageQuery, StaticPageQueryVariables>(StaticPageDocument, options);
        }
export type StaticPageQueryHookResult = ReturnType<typeof useStaticPageQuery>;
export type StaticPageLazyQueryHookResult = ReturnType<typeof useStaticPageLazyQuery>;
export type StaticPageQueryResult = Apollo.QueryResult<StaticPageQuery, StaticPageQueryVariables>;
export const TagsDocument = gql`
    query tags($where: JSON!) {
  tags(where: $where) {
    id
    name
    slug
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTagsQuery(baseOptions: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;